import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Hochwertige Vertrauenskarte im Kreditkartenformat (3.375 × 2.125 in).
 * - Dunkelblau / Weiß / dezentes Gold
 * - QR-Code vom Backend
 * - Notfall-ID, Name, „Im Notfall bitte QR-Code scannen."
 */
export default function TrustCardPreview({ name, notfallId, qrSrc, label = "VERTRAUENSKARTE", scanHint = "Im Notfall bitte QR-Code scannen.", className = "" }) {
  return (
    <div
      data-testid="trust-card-preview"
      className={`trust-card-print relative w-full max-w-[420px] aspect-[1.586/1] rounded-3xl overflow-hidden text-white shadow-[0_24px_60px_-20px_rgba(15,23,42,0.35),0_8px_24px_-12px_rgba(15,23,42,0.25)] ${className}`}
      style={{
        background:
          "linear-gradient(135deg, #0F172A 0%, #1E293B 55%, #0F172A 100%)",
      }}
    >
      {/* subtle gold accent */}
      <div className="absolute top-0 left-7 h-[2px] w-12 bg-amber-400/90" />
      <div className="absolute -top-24 -right-24 h-56 w-56 rounded-full bg-amber-400/10 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 h-32 w-32 rounded-full bg-emerald-400/5 blur-3xl pointer-events-none" />

      <div className="relative h-full flex flex-col p-6">
        {/* Top: logo + label */}
        <div className="flex items-start justify-between">
          <div>
            <div className="font-serif text-[15px] tracking-tight leading-none">ALLES GEREGELT.</div>
            <div className="text-[9px] uppercase tracking-[0.28em] text-amber-300/90 mt-2">{label}</div>
          </div>
          <ShieldCheck className="h-5 w-5 text-amber-300/80" strokeWidth={1.4} />
        </div>

        {/* Middle: name + ID + QR */}
        <div className="flex-1 flex items-end justify-between mt-6 gap-4">
          <div className="min-w-0 pb-1">
            <div className="font-serif text-[22px] leading-tight truncate" data-testid="trust-card-name">{name || "—"}</div>
            <div className="text-[9px] uppercase tracking-[0.2em] text-slate-400 mt-2">Notfall-ID</div>
            <div className="font-mono text-[13px] tracking-[0.1em] text-white" data-testid="trust-card-notfall-id">{notfallId || "—"}</div>
          </div>
          <div className="shrink-0">
            {qrSrc ? (
              <div className="bg-white p-1.5 rounded-xl">
                <img src={qrSrc} alt="QR" className="h-[88px] w-[88px] block" />
              </div>
            ) : (
              <div className="h-[88px] w-[88px] rounded-xl bg-white/5 border border-white/10" />
            )}
          </div>
        </div>

        {/* Footer hint */}
        <div className="text-[9px] uppercase tracking-[0.22em] text-slate-400 mt-3">{scanHint}</div>
      </div>
    </div>
  );
}
